// extracted by mini-css-extract-plugin
export var hidden = "_vu-0";